import type { PropsWithChildren } from 'react'

import { getFiltersSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { tk } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const GridTabsWrapper = styled.div`
  width: 100%;
  border-bottom: 2px solid ${tk('color_semantic_border')};
  display: flex;
  flex-direction: row;
  overflow-x: auto;
`

export function GridTabsNew({ children }: PropsWithChildren) {
  const { isEmpty, error } = usePricesSelector(getFiltersSelector)
  if (isEmpty || error)
    return null

  return <GridTabsWrapper>{children}</GridTabsWrapper>
}
